<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
  <div>{{content}}</div>

  <br>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>{{confirm}}</button>
</mat-dialog-actions>